import { render } from "./404.vue?vue&type=template&id=083cc826"
const script = {}
script.render = render

export default script